function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#202020;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M116.77,57.2q-46.12,0-92.24,0a2.18,2.18,0,0,1-2.28-1.11c-1.06-2.05-2.7-2.61-5-2.52-5.28.19-10.57.05-15.86.08A6.35,6.35,0,0,0,0,54a5.93,5.93,0,0,0,.44,1.35c6.05,9.8,12.13,19.59,18.16,29.39a1.78,1.78,0,0,0,1.77,1q42.81,0,85.63,0a1.63,1.63,0,0,0,1.76-1.25q5.05-12.57,10.17-25.13c.14-.34.35-.65.52-1v-.92A12.08,12.08,0,0,0,116.77,57.2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M83,53.24H110c1.59,0,2.2-.57,2.2-2.13q0-6,0-11.92c0-1.63-.58-2.16-2.27-2.16H83c-1.72,0-2.29.57-2.29,2.28,0,3.9,0,7.8,0,11.69C80.73,52.64,81.32,53.24,83,53.24Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M100.7,20c-2.82,0-5.63,0-8.45,0a1.19,1.19,0,0,0-1.34,1.36c0,3.62,0,7.25,0,10.87,0,1,.46,1.36,1.43,1.35q4.16,0,8.33,0c1,0,1.39-.4,1.37-1.38,0-1.81,0-3.62,0-5.43s0-3.55,0-5.33C102.07,20.47,101.66,20,100.7,20Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M60.22,53.46c3.09,0,6.17,0,9.26,0a1,1,0,0,0,1.2-1.18V42.89a1,1,0,0,0-1.13-1.14H60.06c-.77,0-1.09.43-1.08,1.18,0,1.59,0,3.17,0,4.75s0,3,0,4.51C59,53.07,59.34,53.46,60.22,53.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M53.24,41.74H43.87a1,1,0,0,0-1.13,1.13c0,3.12,0,6.25,0,9.37,0,.83.35,1.2,1.17,1.2,3.09,0,6.17,0,9.26,0,.89,0,1.25-.39,1.24-1.26,0-1.54,0-3.08,0-4.62s0-3.09,0-4.63C54.42,42.13,54.06,41.74,53.24,41.74Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M60.14,38.21q4.68,0,9.37,0c.86,0,1.18-.38,1.17-1.18q0-4.62,0-9.24c0-.89-.41-1.22-1.29-1.19-1.54,0-3.08,0-4.62,0s-3.09,0-4.63,0c-.85,0-1.18.36-1.17,1.18Q59,32.4,59,37C59,37.83,59.28,38.22,60.14,38.21Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M26.54,47.58c0,1.58,0,3.16,0,4.74,0,.78.34,1.13,1.1,1.13,3.12,0,6.24,0,9.36,0,.84,0,1.15-.38,1.15-1.21q0-4.68,0-9.36c0-.79-.35-1.13-1.1-1.13H27.67c-.81,0-1.17.36-1.15,1.2C26.56,44.49,26.54,46,26.54,47.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M42.74,36.92c0,.93.31,1.32,1.28,1.29,1.54-.05,3.08,0,4.62,0s3,0,4.51,0c.88,0,1.27-.28,1.26-1.19q0-4.62,0-9.24c0-.91-.4-1.19-1.27-1.18-3,0-6.09,0-9.13,0-1,0-1.28.37-1.27,1.3C42.77,30.91,42.77,33.91,42.74,36.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M94,16.65c2.2,0,4.39,0,6.59,0,1,0,1.49-.37,1.47-1.43,0-3.36.33-3.21-3.05-3.18-.27,0-.53,0-1,0V5c0-1,0-2.08,0-3.12C98,.63,97.39,0,96.43,0S95,.62,95,1.87c0,2.93,0,5.85,0,8.78V12c-1,0-1.92,0-2.83,0a1.13,1.13,0,0,0-1.28,1.28C90.92,16.58,90.55,16.71,94,16.65Z"
})));
function SvgIconBoat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 118.45 85.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoat);
export default __webpack_public_path__ + "static/media/icon-boat.3430e1ff99fdfa2f1f91b7bf24370a66.svg";
export { ForwardRef as ReactComponent };